import {
  ColDef,
  ColGroupDef,
  ValueFormatterParams,
  ValueFormatterFunc,
} from "ag-grid-community";
import { NUMBERS } from "../../../utils/Enum";
import SupplyChainVendorInfo from "../../../interfaces/SearchGridVendorInfo";

const scoreFormatter: ValueFormatterFunc = (
  params: ValueFormatterParams<number>,
): string => {
  const value = params?.value;

  if (!params?.data) {
    return "";
  }

  switch (true) {
    case value === NUMBERS.ZERO:
      return "0.00";
    case Number.isNaN(value) || value === null:
      return "Not Available";
    case value < NUMBERS.ZERO || value > NUMBERS.TEN:
      return "Not Applicable";
    default:
      return Number(value).toFixed(2);
  }
};

const privateLabelFormatter: ValueFormatterFunc = (
  params: ValueFormatterParams<string>,
): string => {
  const value = params?.value;

  if (!params?.data) {
    return "";
  }

  switch (true) {
    case value === "NK":
      return "N";
    case value === "KS":
      return "Y";
    //catch for data breach
    case value === null:
    default:
      return "Not Available";
  }
};

export const ColumnDefs: (
  | ColDef<SupplyChainVendorInfo>
  | ColGroupDef<SupplyChainVendorInfo>
)[] = [
  {
    field: "countryRegion",
    headerName: "Selling\nCountry/\n Region",
    minWidth: 150,
  },
  {
    field: "deptNumber",
    headerName: "Dept",
    minWidth: 100,
    filter: "agNumberColumnFilter",
  },
  {
    field: "deptName",
    headerName: "Department Name",
    minWidth: 140,
    initialHide: true,
    filter: true,
  },
  {
    field: "vendorNumber",
    headerName: "Vendor #",
    filter: "agNumberColumnFilter",
    minWidth: 120,
  },
  {
    field: "vendorNameEnglish",
    headerName: "Vendor Name\n(English)",
    minWidth: 150,
    filter: true,
  },
  {
    field: "vendorNameNative",
    headerName: "Vendor Name\n(Native)",
    initialHide: true,
    minWidth: 150,
    filter: true,
  },
  {
    field: "privateLabel",
    headerName: "Private\nLabel",
    minWidth: 150,
    filter: true,
    valueFormatter: privateLabelFormatter,
  },
  {
    field: "category1Description",
    headerName: "Category\nDescription",
    initialHide: true,
    filter: true,
    minWidth: 200,
  },
  {
    field: "category12Description",
    headerName: "Category12\nDescription",
    initialHide: true,
    filter: true,
    minWidth: 200,
  },
  {
    field: "category123Description",
    headerName: "Category123\nDescription",
    initialHide: true,
    filter: true,
    minWidth: 200,
  },
  {
    field: "itemNumber",
    headerName: "Item #",
    filter: "agNumberColumnFilter",
    minWidth: 120,
  },
  {
    field: "itemDescription",
    headerName: "Item\nDescription",
    filter: true,
    minWidth: 150,
  },
  {
    field: "itemDescription2",
    headerName: "Item\nDescription2",
    initialHide: true,
    filter: true,
    minWidth: 150,
  },
  {
    field: "commodity",
    headerName: "Commodity",
    minWidth: 150,
  },
  {
    field: "overallRiskScore",
    headerName: "Overall\nScore",
    minWidth: 150,
    filter: "agNumberColumnFilter",
    filterParams: {
      defaultOption: "inRange",
    },
    valueFormatter: scoreFormatter,
  },
  {
    field: "transparencyScore",
    headerName: "Transparency\nScore",
    minWidth: 180,
    filter: "agNumberColumnFilter",
    filterParams: {
      defaultOption: "inRange",
    },
    valueFormatter: scoreFormatter,
  },

  {
    field: "environmentalRiskScore",
    headerName: "Environmental\nScore",
    minWidth: 160,
    filter: "agNumberColumnFilter",
    filterParams: {
      defaultOption: "inRange",
    },
    valueFormatter: scoreFormatter,
  },
  {
    field: "humanRightsRiskScore",
    headerName: "Human Rights\nScore",
    minWidth: 150,
    filter: "agNumberColumnFilter",
    filterParams: {
      defaultOption: "inRange",
    },
    valueFormatter: scoreFormatter,
  },

  {
    field: "scmIDNum",
    headerName: "SCM ID",
    minWidth: 120,
    filter: "agNumberColumnFilter",
    filterParams: {
      defaultOption: "inRange",
    },
  },
];
